import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import QRReader from './components/QRReader';
import Complete from './components/Completely';

const App = () => {
    return (
        <Router>
            <Routes>
                <Route path="/:txHash" element={<QRReader />} />
                <Route path="/complete" element={<Complete />} />
            </Routes>
        </Router>
    );
};

export default App;
